// extracted by mini-css-extract-plugin
module.exports = {"container":"PicsCarousel_container__3xHP0"};